export const PROFILE_NAV_SCROLL_OFFSET = 0;
export const PROFILE_NAV_BREAKPOINT_OFFSET = 30;

export const PROFILE_PAGE_ABOUT = 'about';
export const PROFILE_PAGE_PORTFOLIO = 'portfolio';
export const PROFILE_PAGE_COMMUNITIES = 'communities';
export const PROFILE_PAGE_CREDENTIALS = 'credentials';
export const PROFILE_PAGE_BLOG = 'blog';
export const PROFILE_PAGE_DEFAULT = PROFILE_PAGE_ABOUT;

export const PROFILE_BADGE_MAX = 25;
export const PROFILE_FANS_MAX = 25;

export const PROFILE_HEADER_BACKGROUND_COLORS = [
  '#094967',
  '#068487',
  '#54265e',
  '#aa024f',
  '#87405d',
  '#615c68',
  '#14332d',
  '#303377',
  '#4d4d4d',
  '#34353a',
  '#8c3236',
];
